import MediaQuery from './media-query'
import { useTheme } from '@mui/system'

const ArtDirectionWrapper = ({ responsiveProps, breakpoints = {}, ChildComponent, children, ...props }) => {
	const theme = useTheme()
	const artBreakpoints = { ...theme.breakpoints.values, ...breakpoints }
	const responsiveBreakpoints = Object.keys(responsiveProps)

	responsiveBreakpoints.sort((firstEl, secondEl) => {
		if (artBreakpoints[firstEl] < artBreakpoints[secondEl]) {
			return -1
		}
		if (artBreakpoints[firstEl] > artBreakpoints[secondEl]) {
			return 1
		}
		return 0
	})

	return responsiveBreakpoints.map((breakpoint, index) => {
		const nextBreakpoint = responsiveBreakpoints[index + 1]
		const componentProps = {
			...props,
			...(typeof responsiveProps[breakpoint] === 'object' ? responsiveProps[breakpoint] : {}),
			breakpoint,
		}

		return (
			<MediaQuery
				key={breakpoint}
				from={artBreakpoints[breakpoint]}
				to={nextBreakpoint && artBreakpoints[nextBreakpoint] - 1}
			>
				<ChildComponent {...componentProps}>{children}</ChildComponent>
			</MediaQuery>
		)
	})
}

export default ArtDirectionWrapper
